/**
 * src/utils/constants.js
 * アプリケーション全体で使用する定数定義（完全版）
 */

// ========== 惑星・小惑星・感受点シンボル ==========
export const PLANET_SYMBOLS = {
  Sun: "☉",
  Moon: "☽",
  Mercury: "☿",
  Venus: "♀",
  Mars: "♂",
  Jupiter: "♃",
  Saturn: "♄",
  Uranus: "♅",
  Neptune: "♆",
  Pluto: "♇",
  Earth: "🌍",
  NorthNode: "☊",
  SouthNode: "☋",
  ASC: "Asc",
  MC: "MC",
  IC: "IC",
  DSC: "Dsc",
};

// ========== 日本語名称マップ ==========
export const PLANET_NAMES_JP = {
  Sun: "太陽",
  Moon: "月",
  Mercury: "水星",
  Venus: "金星",
  Mars: "火星",
  Jupiter: "木星",
  Saturn: "土星",
  Uranus: "天王星",
  Neptune: "海王星",
  Pluto: "冥王星",
  Earth: "地球",
  NorthNode: "ノード(北)",
  SouthNode: "ノード(南)",
  ASC: "アセンダント",
  MC: "MC",
  IC: "IC",
  DSC: "ディセンダント",
};

// ========== 惑星リスト ==========
export const PLANETS = [
  "Sun",
  "Moon",
  "Mercury",
  "Venus",
  "Mars",
  "Jupiter",
  "Saturn",
  "Uranus",
  "Neptune",
  "Pluto",
];

// ========== 金融占星術用スコア設定 ==========
export const PLANET_SCORES = {
  Sun: 10,
  Moon: 8,
  Mercury: 5,
  Venus: 7,
  Mars: 6,
  Jupiter: 12,
  Saturn: -10,
  Uranus: 4,
  Neptune: -5,
  Pluto: -8,
};

export const ASP_SCORES = {
  Conjunction: 10,
  Opposition: -10,
  Trine: 8,
  Square: -8,
  Sextile: 5,
  "Semi-Sextile": 2,
  Quincunx: -3,
  "Semi-Square": -4,
  Sesquiquadrate: -4,
};

// ========== デフォルト分析対象銘柄リスト ==========
export const DEFAULT_ASSETS = [
  {
    id: "btc",
    name: "Bitcoin (BTC)",
    category: "仮想通貨",
    date: "2009-01-03",
    time: "18:15",
    timezone: 0,
    description: "Genesis Block",
  },
  {
    id: "eth",
    name: "Ethereum (ETH)",
    category: "仮想通貨",
    date: "2015-07-30",
    time: "15:26",
    timezone: 0,
    description: "Frontier Release",
  },
  {
    id: "xrp",
    name: "Ripple (XRP)",
    category: "仮想通貨",
    date: "2012-09-26",
    time: "12:00",
    timezone: 0,
    description: "OpenCoin創設",
  },
  {
    id: "sol",
    name: "Solana (SOL)",
    category: "仮想通貨",
    date: "2020-03-16",
    time: "12:00",
    timezone: 0,
    description: "Mainnet Beta",
  },

  // 米国主要株式
  {
    id: "aapl",
    name: "Apple (AAPL)",
    category: "米国株",
    date: "1980-12-12",
    time: "09:30",
    timezone: -5,
    description: "NASDAQ IPO",
  },
  {
    id: "nvda",
    name: "NVIDIA (NVDA)",
    category: "米国株",
    date: "1999-01-22",
    time: "09:30",
    timezone: -5,
    description: "NASDAQ IPO",
  },
  {
    id: "meta",
    name: "Meta (META)",
    category: "米国株",
    date: "2012-05-18",
    time: "09:30",
    timezone: -4,
    description: "NASDAQ IPO (FB)",
  },
  {
    id: "msft",
    name: "Microsoft (MSFT)",
    category: "米国株",
    date: "1986-03-13",
    time: "09:30",
    timezone: -5,
    description: "NASDAQ IPO",
  },
  {
    id: "googl",
    name: "Alphabet (GOOGL)",
    category: "米国株",
    date: "2004-08-19",
    time: "09:30",
    timezone: -4,
    description: "NASDAQ IPO",
  },
  {
    id: "tsla",
    name: "Tesla (TSLA)",
    category: "米国株",
    date: "2010-06-29",
    time: "09:30",
    timezone: -4,
    description: "NASDAQ IPO",
  },

  {
    id: "dji",
    name: "ダウ平均 (DJI)",
    category: "株価指数",
    date: "1896-05-26",
    time: "10:00",
    timezone: -5,
    description: "NYSE開場時刻",
  },
  {
    id: "spx",
    name: "S&P 500 (SPX)",
    category: "株価指数",
    date: "1957-03-04",
    time: "09:30",
    timezone: -5,
    description: "Index Launch",
  },
  {
    id: "ndx",
    name: "NASDAQ 100 (NDX)",
    category: "株価指数",
    date: "1985-01-31",
    time: "09:30",
    timezone: -5,
    description: "Index Launch",
  },
  {
    id: "nikkei",
    name: "日経225 (N225)",
    category: "株価指数",
    date: "1950-09-07",
    time: "09:00",
    timezone: 9,
    description: "TSE再開",
  },
  {
    id: "gold",
    name: "Gold (XAU)",
    category: "コモディティ",
    date: "1919-09-12",
    time: "10:30",
    timezone: 0,
    description: "London Gold Fix",
  },
  {
    id: "usdjpy",
    name: "USD/JPY",
    category: "為替",
    date: "1971-08-15",
    time: "21:00",
    timezone: -5,
    description: "Nixon Shock",
  },
];

// ========== デフォルトカラー設定 ==========
export const DEFAULT_PLANET_COLORS = {
  Sun: "#ff3c00",
  Moon: "#C0C0C0",
  Mercury: "#808080",
  Venus: "#FF69B4",
  Mars: "#FF4500",
  Jupiter: "#DAA520",
  Saturn: "#4B0082",
  Uranus: "#00CED1",
  Neptune: "#4169E1",
  Pluto: "#8B4513",
  NorthNode: "#458B74",
  SouthNode: "#458B74",
  ASC: "#949494",
  MC: "#949494",
  IC: "#949494",
  DSC: "#949494",
  Earth: "#2ecc71",
};

export const DEFAULT_SIGN_COLORS = {
  "♈": "#e74c3c",
  "♉": "#27ae60",
  "♊": "#f1c40f",
  "♋": "#3498db",
  "♌": "#e67e22",
  "♍": "#95a5a6",
  "♎": "#fd79a8",
  "♏": "#8e44ad",
  "♐": "#2980b9",
  "♑": "#2c3e50",
  "♒": "#00cec9",
  "♓": "#74b9ff",
};

export const PLANET_COLORS = DEFAULT_PLANET_COLORS;
